import { FC, useMemo, useState } from 'react'
import { AnimalDto, AnimalInsightsDto, AnimalInsightsDtoType } from '../../../interactors/gen/backendClient'
import { Box } from '@mui/material'
import { InfoBox } from '../../common/InfoBox'

interface Props {
  animal: AnimalDto
}

export const AllAnimalInsightsInfoBox: FC<Props> = ({ animal }) => {
  const [isCollapsed, setCollapsed] = useState(true)
  const order: Array<AnimalInsightsDtoType> = ['error', 'warning', 'info', 'success']
  const hasAnyAnimalImage =
    Boolean(animal.images?.profileImageKey && animal.images.profileImageKey !== '') ||
    Boolean(animal.images?.otherImagesKeys && animal.images.otherImagesKeys.length > 0)

  const orderedInsights = useMemo(() => {
    const byType: Record<AnimalInsightsDtoType, AnimalInsightsDto[]> = {
      error: [],
      warning: [],
      info: [],
      success: [],
    }
    animal.insights
      .filter((insight) => {
        const normalizedMessage = insight.message.toLowerCase()
        const isPhotoPublicationInsight =
          normalizedMessage.includes('photo') &&
          (normalizedMessage.includes("publier l'annonce") ||
            normalizedMessage.includes('publier l’annonce') ||
            normalizedMessage.includes('annonc'))

        if (isPhotoPublicationInsight && hasAnyAnimalImage) {
          return false
        }

        return true
      })
      .forEach((insight) => {
        byType[insight.type]?.push(insight)
      })
    return order.flatMap((type) => byType[type] || [])
  }, [animal.insights, hasAnyAnimalImage])

  const normalizeInsightMessage = (message: string) => {
    const normalizedReminderMessage = message.replace(
      /Vous avez un rendez-vous de santé \(([^)]+)\) prévu le (\d{2}\/\d{2}\/\d{4}) qui n'a pas été validé\.?/i,
      (_, operationType: string, date: string) => {
        const normalizedOperationType = operationType.toLowerCase() === 'antipuce' ? 'Antiparasitaire' : operationType

        return `${normalizedOperationType} prévu le ${date} : non validé`
      }
    )

    return normalizedReminderMessage
      .replaceAll('Contacter d’urgence votre vétérinaire', 'Rapprochez-vous de votre vétérinaire')
      .replaceAll("Contacter d'urgence votre vétérinaire", 'Rapprochez-vous de votre vétérinaire')
  }

  return (
    <Box sx={{ marginBottom: 1, marginTop: 1.5 }}>
      {orderedInsights.length > 0 && (
        <Box sx={{ marginBottom: 2 }}>
          {(isCollapsed ? [orderedInsights[0]] : orderedInsights).map((insight, index) => (
            <InfoBox
              key={`${insight.type}-${index}`}
              messageType={insight.type}
              content={normalizeInsightMessage(insight.message)}
              isCollapsed={isCollapsed && index === 0}
              hiddenCount={isCollapsed ? orderedInsights.length - 1 : 0}
              onToggleCollapse={() => setCollapsed((prev) => !prev)}
              hasCollapseButton={orderedInsights.length > 1}
            />
          ))}
        </Box>
      )}
    </Box>
  )
}
